import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IBadgeStatus, IUser } from '../../interface/IUser';
import { incrementUser } from '../../redux/userSlice';
import ProfileModalDialog from './ProfileModal';
import { Badge } from '@mui/material';

import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const pages = ['Home', 'Orders','Tasks','Products','Reports'];
const settings = ['Profile', 'Logout'];

function ResponsiveAppBar() {
  const [openRoleDialog, setOpenRoleDialog] = React.useState<boolean>(false); 
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const dispatch = useDispatch()
  const userinfo:IUser = useSelector((state: any) => state.user)
  const badgeInfo:IBadgeStatus = useSelector((state: any) => state.badge)


  
  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };
  
  const handleCloseNavMenu = (event:any) => {
    setAnchorElNav(null); 
  };

  const handleCloseUserMenu = (event: any)  => {
    setAnchorElUser(null);
    const action =event.target.innerText ;    
    if (action ==='Logout')
      {
        let loginUserData :IUser = {
          id: 1,
          isSignedIn: false,
          userName: '',
          userLastName: 'test',
          usermail: '',
          userRoleName: '',
          userRoles: [{
            id: 1,
            role: 'none'
          }],
          color: 'grey',
          userRoleId: 0
        }                
        dispatch( incrementUser(loginUserData))
      }
      else if(action ==='Profile'){
        setOpenRoleDialog(true);

      }
  };

  return (
    <>
    <ProfileModalDialog openRoleDialog={openRoleDialog} setOpenRoleDialog={setOpenRoleDialog}/>
    <AppBar sx={{bgcolor:"black", height: '70px'}} position="static" >
      <Container maxWidth= 'xl'>
        <Toolbar disableGutters>
          <img  src='https://www.compulocks.com/media/logo/stores/1/Logo-Compulocks.png'></img>                    
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
            <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'center',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'center',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none'  },                
              }}              
            >
              {pages.filter((p)=>{if (p === 'Reports' && userinfo.userRoleName !== 'Administrator') return false; return true}).map((page) => (
                
                <MenuItem key={page} onClick={(e)=> handleCloseNavMenu(e)} >                
                 <Link to={page.toLocaleLowerCase()} style={{textDecoration:'none', color:'black'}} > 
                  {page}
                </Link>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 1,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 500,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.filter((p)=>{if (p === 'Reports' && userinfo.userRoleName !== 'Administrator') return false; return true}).map((page) => (
              <Button
                key={page}
                value ={page}
                onClick={(e) => {handleCloseNavMenu(e)}}
                
                sx={{ my: 1, color: 'white', display: 'block' ,padding: '1rem' }}
              >
                 <Link to={page.toLocaleLowerCase()} style={{textDecoration:'none', color:'white'}} >
                 {page}
                 {page === 'Orders' ?
                  <Badge badgeContent={badgeInfo.orderCount} color="primary" >
                       <PlaylistAddCheckIcon/>  
                    </Badge> :
                    page === 'Tasks' ? 
                    <Badge badgeContent={badgeInfo.taskCount} color="success">
                      <ShoppingCartIcon/>
                    </Badge> :
                      // page === 'Reports' ? 
                      // <AssessmentRoundedIcon/>
                      // :                      
                      // <HomeIcon/>
                      <></>
                      }  

                
                </Link>
                {/* ['Home', 'Orders','Tasks','Reports']; */}
                          
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0  }}>          
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={userinfo.userName}>
                {userinfo.userName?.substring(0,1)}
                  </Avatar>
                              
              </IconButton>
              
            </Tooltip>
             
            <Menu
              sx={{ mt: '35px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={(e)=>handleCloseUserMenu(e)}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={(e)=>{handleCloseUserMenu(e)}}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>            
          </Box>
          <Box sx={{ flexGrow: 0  }}>
            <h3 style={{ paddingLeft: "0.3rem" , color: "LightCoral"}}> { userinfo?.userRoleName} </h3>            
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
    </>
  );
}
export default ResponsiveAppBar;
